import React from 'react';
import { useTema, type CasaTema } from '@components/M02/casaTema';

/**
 * Hueso — el esqueleto de carga. I-244 · diseño ganador (conflicto 17): `handoff_claude_ingresos_vestido/casa-estados.jsx:168`
 * (12-sep): degradado `chip` → `panelSoft` → `chip`, 1.3 s (el de obra, 1.4 s y `raise`, es de 7-sep y pierde).
 * La animación `casaBrilla` vive en el `<style>` del HTML del diseño; aquí se inyecta UNA vez al primer uso.
 * ⚠️ Con `className` (caso de `pages/dashboard/_shared` `Skeleton`, que dimensiona con Tailwind) NO se escribe el radio ni el tamaño
 * en línea, para no pisar el `rounded-*`/`w-*`/`h-*` del llamador; sin `className` valen `w`, `h` (12) y `r` (6) del diseño.
 */
const ID_ESTILO = 'casa-brilla-keyframes';
function asegurarKeyframes() {
  if (typeof document === 'undefined' || document.getElementById(ID_ESTILO)) return;
  const s = document.createElement('style');
  s.id = ID_ESTILO;
  s.textContent = '@keyframes casaBrilla{0%{background-position:100% 0}100%{background-position:-100% 0}}';
  document.head.appendChild(s);
}

/** El degradado del diseño (casa-estados.jsx:168): chip 25% → panelSoft 37% → chip 63%. */
export const degradadoDelHueso = (T: CasaTema): string =>
  `linear-gradient(90deg, ${T.chip} 25%, ${T.panelSoft} 37%, ${T.chip} 63%)`;

export interface HuesoProps {
  w?: number | string;
  h?: number | string;
  r?: number;
  className?: string;
  style?: React.CSSProperties;
  tema?: CasaTema;
}

export const Hueso: React.FC<HuesoProps> = ({ w, h, r, className, style, tema }) => {
  const propio = useTema();
  const T = tema ?? propio;
  asegurarKeyframes();
  const medidas: React.CSSProperties = className
    ? { width: w, height: h, borderRadius: r }
    : { width: w, height: h ?? 12, borderRadius: r ?? 6 };
  return (
    <span data-hueso="" className={className} style={{
      display: 'block', ...medidas,
      // los dos colores también van como variables: el tema viaja con la pieza y se puede leer en pruebas
      ['--hueso-a' as string]: T.chip, ['--hueso-b' as string]: T.panelSoft,
      background: degradadoDelHueso(T),
      backgroundSize: '400% 100%', animation: 'casaBrilla 1.3s ease-in-out infinite',
      ...style,
    }} />
  );
};
